import { Box, Button, Card, CardContent, Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import ReleaseManagement from "./ReleaseManagementModel";
import HelpIcon from '@mui/icons-material/Help';
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import axiosBase from "../common/axiosBase";
import coreConfig from "../common/coreConfig";
import { logger } from "../App";


export default function ReleaseScreen() {

	const theme = useTheme();
	const screen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
	const is1024x768 = useMediaQuery('(max-width: 1024px) and (max-height: 768px)');
	const navigate = useNavigate();
	const [scopeData, setScopeData] = useState({});
	const { id } = useParams();
	const { apiConfig } = coreConfig;

	const navigateToForm = ({ id }) => {
		navigate(`/revision/${id}`);
	};

	const onCellClick = ({ cellParams, event, details }) => {
		let action = null;
		if (cellParams.field === 'actions') {
			action = details?.action;
			if (!action) {
				const el = event.target.closest('button');
				if (el) {
					action = el.dataset.action;
				}
			}
		}
		if (!action) return;
		if (action === 'Edit') {
			navigateToForm({ id: cellParams.id });
		}
		else return false;
	};

	const fetchData = async () => {
		try {
			const response = await axiosBase({
				method: apiConfig.reqMethod.GET,
				api: `${apiConfig.endpoints.equipment}/${id}`
			});
			setScopeData(response.data.data);
		} catch (error) {
			logger.error({ error, message: "Error fetching equipment data" });
		}
	};
	const equipmentId = parseInt(scopeData.EquipmentId);
	useEffect(() => {
		if (!id) return;
		fetchData();
	}, [id]);
	if (!equipmentId) {
		return <></>;
	}
	return (
		<Grid container>
			<Grid size={{ xs: 12, md: 12}} sx={{ marginBottom: '10px', marginTop: "10px" }}>
				<Box display="flex" alignItems="center" justifyContent='space-between' sx={{
					backgroundColor: "#fff",
					borderRadius: '5px',
					padding: '10px'
				}}>
					<Typography variant="h5" sx={{ color: 'text.secondary' }}>Releases - {scopeData.ModelName}</Typography>
					<Box>
						<Button variant="contained" onClick={() => navigate(window.history.back())}>Back</Button>
						<IconButton color="primary" title='Help' size="large">
							<HelpIcon fontSize="inherit" />
						</IconButton>
					</Box>
				</Box>
			</Grid>
			<Grid container>
				<Grid size={12} height={'fit-content'}>
					<Card>
						<CardContent>
							<Grid container spacing={2} height={'fit-content'}>
								<Card sx={{ backgroundColor: '#d3d0d094', padding: '1em', textWrap: 'nowrap', width: '30%', height: '12.5em', alignSelf: 'center', marginLeft: '4em', alignContent: 'center' }}>
									<Grid size={{ xs: 6, md: is1024x768 ? 6 : 3}} display="flex" justifyContent="space-between" height={'fit-content'}>
										<Grid
											container
											sx={{
												flexDirection: 'row-reverse',
												padding: '1em',
												'& .keyValueRow': {
													display: 'grid',
													gridTemplateColumns: screen || is1024x768 ? '130px 50px 50px' : '150px 100px 100px',
													'& .keyLabel': { fontWeight: 'bold', width: 'auto' },
													'& .keyValue': { marginLeft: screen || is1024x768 ? '-2em' : '-4em' }
												}
											}}
										>
											<Grid size={{ xs: 12, md: 8 }} className="keyValueRow">
												<Typography variant="body1" className="keyLabel">
													Equipment Model :
												</Typography>
												<Typography variant="body1" component="span" />
												<Typography variant="body1" className="keyValue">
													{scopeData.ModelName || ""}
												</Typography>
											</Grid>
											<Grid size={{xs: 12, md: 8 }} className="keyValueRow">
												<Typography variant="body1" className="keyLabel">
													Equipment Type :
												</Typography>
												<Typography variant="body1" component="span" />
												<Typography variant="body1" className="keyValue">
													{' '}
													{scopeData.EquipmentType || ""}
												</Typography>
											</Grid>
											<Grid size={{ xs: 12, md: 8 }} className="keyValueRow">
												<Typography variant="body1" className="keyLabel">
													Equipment Family :
												</Typography>
												<Typography variant="body1" component="span" />
												<Typography variant="body1" className="keyValue">
													{' '}
													{scopeData.EquipmentFamily || ""}
												</Typography>
											</Grid>
										</Grid>
									</Grid>
								</Card>
								<Grid size={{ xs:6, md: is1024x768 ? 6 : 2 }} display="flex" justifyContent="space-between">
									<Box>
										<Box
											component="img"
											src={`/${scopeData.EquipmentTypeImage}`}
											alt="washer"
											sx={{ height: 245, paddingLeft: 10, marginBottom: '1em' }}
										/>
									</Box>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			<Grid size={{ xs: 12}} mt={2}>
				<ReleaseManagement.Grid
					onCellDoubleClickOverride={navigateToForm}
					onCellClick={onCellClick}
					baseFilters={[{
						field: "EquipmentId",
						operator: "equals",
						value: equipmentId,
						type: "number"
					}]} key={scopeData.EquipmentId} />
			</Grid>
		</Grid>
	);
}